import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const CategoriaServiciosView = lazy(() => import('../../container/configuracion/categoriaServicios/Index'));
const CategoriaServiciosForm = lazy(() => import('../../container/configuracion/categoriaServicios/Form'));

const CategoriaServiciosRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/catalogos/categorias-servicios/listado`} component={CategoriaServiciosView} />      
      <Route path={`${path}/catalogos/categorias-servicios/agregar`} component={CategoriaServiciosForm} />
      <Route exact path={`${path}/catalogos/categorias-servicios/editar/:id`} component={CategoriaServiciosForm} />  
    </Switch>
  );
};

export default CategoriaServiciosRoute;

